import { useLang } from "@/context/LanguageContext";

export default function Privacy() {
  const { t } = useLang();
  const sections = ["s1","s2","s3","s4","s5","s6","s7"];
  return (
    <div className="max-w-4xl mx-auto px-5 lg:px-8 py-20" data-testid="privacy-page">
      <h1 className="text-4xl sm:text-5xl font-bold">{t.privacy.title}</h1>
      <p className="mt-2 text-xs text-slate-500">{t.privacy.updated}</p>
      <p className="mt-6 text-slate-300 leading-relaxed">{t.privacy.intro}</p>
      <div className="mt-10 space-y-6">
        {sections.map((s) => (
          <section key={s} className="card-mift p-6" data-testid={`privacy-${s}`}>
            <h2 className="text-lg font-semibold text-blue-300">{t.privacy[`${s}_h`]}</h2>
            <p className="mt-3 text-slate-300 leading-relaxed text-sm">{t.privacy[`${s}_body`]}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
